module.exports = __webpack_public_path__ + "fonts/AlteDIN1451Mittelschrift.f328cb32.eot";